export const isLocalEnv = () => process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === 'local';
export const isDevEnv = () => process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === 'development';
